/**
 * Словник: pt.
 * Згенеровано tool/gen_web_locales.py з lib/l10n/app_pt.arb — руками не правити.
 *
 * ⚠️ Новий рядок: спершу в ARB усіх мов, потім ключ у en.ts і перегенерація.
 * Паритет ключів перевіряється на збірці (npm run check:i18n).
 */
export default {
  waiting: "⏳ Aguardando o outro participante...",
  connectionLost: "Conexão perdida",
  peerLeft: "👋 O outro participante saiu da chamada",
  connectionError: "🚫 Erro de conexão",
  connectionFailedTryAgain: "🚫 Não foi possível conectar ao servidor. Tente novamente.",
  reconnectionFailed: "🚫 Conexão perdida. Não foi possível restabelecê-la após {attempts} tentativas.",
  connectionErrorWithDetails: "🚫 Erro de conexão: {error}",
  speakerLoud: "Alto",
  speakerEar: "Ouvido",
  copyRoomId: "Copiar ID da sala",
  share: "Compartilhar",
  linkCopied: "🔗 Link copiado!",
  idCopied: "🆔 ID copiado!",
  startMeeting: "Iniciar reunião",
  chooseAction: "Escolha uma ação",
  createNewRoom: "Nova sala",
  scheduleCall: "Agendar chamada",
  calendarOpened: "📅 Calendário aberto com sucesso",
  linkCopiedToClipboard: "🔗 Link copiado para a área de transferência",
  enterRoomId: "ID da sala",
  roomIdValidationError: "O ID da sala só pode conter letras, números e hífens",
  joinRoom: "ENTRAR",
  termsAndPrivacyHelp: "Termos e Privacidade | Ajuda",
  invite: "Convidar",
  mySettings: "Meus ajustes",
  peerSettings: "Ajustes da outra pessoa",
  blockRemoteControl: "Bloquear controle remoto",
  iAgreeToTerms: "Concordo com os termos do serviço",
  termsOfUse: "Termos de Uso",
  privacyPolicy: "Política de Privacidade",
  howToUse: "Como usar",
  termsAcceptanceRequired: "Você precisa aceitar os termos para usar o serviço",
  ok: "OK",
  permissionsRequired: "Permissões necessárias",
  permissionsNeededMessage: "Este app precisa das seguintes permissões para funcionar corretamente:",
  permissionsNote: "Observação: ao alterar as permissões nos Ajustes, o iOS reinicia o app. Isso é normal.",
  permissionsEnableMessage: "Ative essas permissões nas configurações do dispositivo para continuar.",
  cancel: "Cancelar",
  openSettings: "Abrir configurações",
  websocketError: "Erro de WebSocket",
  roomFull: "A sala está cheia",
  timeExpired: "Tempo esgotado",
  remaining: "rest.",
  mediaPermissionsRequired: "Chamadas de vídeo precisam de acesso à câmera e ao microfone. Conceda as permissões no seu navegador.",
  mediaPermissionsRequiredMobile: "Chamadas de vídeo precisam de acesso à câmera e ao microfone. Conceda as permissões nas configurações do app.",
  browserSettings: "Configurações do navegador",
  openAppSettings: "Abrir configurações",
  grantPermissions: "Conceder permissões",
  permissionsNotGranted: "Permissões não concedidas. Conceda as permissões para continuar.",
  permissionRequestError: "Erro ao solicitar permissões: {error}",
  camera: "Câmera",
  microphone: "Microfone",
  cameraDescription: "Para transmitir vídeo",
  microphoneDescription: "Para transmitir áudio",
  continueWithoutPermissions: "Continuar sem permissões",
  mediaPermissionsRequiredFallback: "Chamadas de vídeo precisam de permissões de mídia. Conceda as permissões nas configurações do navegador.",
  mediaPermissionsRequiredMobileFallback: "Chamadas de vídeo precisam de permissões de mídia. Conceda as permissões nas configurações do app.",
  browserSettingsFallback: "Configurações do navegador",
  openAppSettingsFallback: "Abrir configurações",
  permissionsPermanentlyDenied: "Permissões negadas permanentemente. Ative-as nas configurações do app.",
  continueText: "Continuar",
  mirror: "Espelhar",
  fitContain: "Ajustar",
  fitCover: "Preencher",
  switchCamera: "Virar",
  block: "Bloquear",
  pip: "PiP",
  mic: "Microfone",
  video: "Vídeo",
  speaker: "Viva-voz",
  readyToConnect: "Vamos conversar?",
  startOneOnOne: "Iniciar videochamada",
  createPrivateLink: "Link pronto em um segundo",
  welcomeExplainer: "Crie um link e envie para quem quiser. Ele abre mesmo sem o app.",
  joinHaveLink: "Tem um link?",
  joinFieldHint: "Cole um link ou ID",
  roomInputInvalid: "Cole um link de chamada ou o ID de uma sala (letras, números e hífens)",
  guestTitle: "Convite para uma chamada de vídeo",
  guestBody: "A sala está pronta. Assim que você entrar, a outra pessoa vai te ver.",
  guestJoin: "Entrar",
  guestFreeNote: "Entrar é sempre grátis",
  guestCreateOwn: "Criar minha própria sala",
  guestInvalidTitle: "Este link parece estar quebrado",
  guestInvalidBody: "Peça o link de novo ou crie sua própria sala.",
  inviteCardTitle: "Sua sala está pronta",
  inviteCardBody: "Envie o link para a pessoa com quem você quer conversar",
  inviteShareLink: "Compartilhar link",
  inviteCopy: "Copiar",
  inviteBrowserHint: "Abre em qualquer navegador. Não é preciso instalar o app.",
  inviteSentHint: "Enviou? A outra pessoa vai aparecer aqui assim que abrir o link.",
  inviteShareMessage: "Entra na minha chamada de vídeo no One2One 👋\nÉ só abrir o link. Funciona no navegador, não precisa instalar nada:\n{link}",
  copyLink: "Copiar link",
  consentBannerText: "Podemos coletar estatísticas de uso? Elas mostram quais recursos as pessoas usam. O conteúdo das chamadas nunca é incluído.",
  consentAllow: "Permitir",
  consentDeny: "Não permitir",
  privacySettingsLink: "Configurações de estatísticas",
} as const;
